export default __webpack_public_path__ + "static/media/textured_paper.45329e8f.png";